import ChallengerConversionModule from "./ChallengerConversionModule";
import ChallengerConversionSagas from "./redux/challengerConversionSaga";
import ChallengerConversionReducer from "./redux/challengerConversionReducer";

export default {
  Component: ChallengerConversionModule,
  moduleName: "challengerConversion",
  saga: ChallengerConversionSagas(),
  reducer: ChallengerConversionReducer
};
